import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KButtonFolder";
var classes = {
    mainWrapperKButton: "".concat(PREFIX, "-mainWrapperKButton"),
    mainWrapperBox: "".concat(PREFIX, "-mainWrapperBox"),
    folderCover: "".concat(PREFIX, "-folderCover"),
    folderContent: "".concat(PREFIX, "-folderContent"),
    innerWrapper: "".concat(PREFIX, "-innerWrapper"),
    innerWrapperButton: "".concat(PREFIX, "-innerWrapperButton"),
    title: "".concat(PREFIX, "-title"),
    icon: "".concat(PREFIX, "-icon"),
    mainActionLink: "".concat(PREFIX, "-mainActionLink"),
    subFolderLink: "".concat(PREFIX, "-subFolderLink")
};
var StyledKButtonFolder = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "showFolderCover" && prop !== "folderCoverUrl" && prop !== "imageComponentActive";
    }
})(function (_a) {
    var _b;
    var theme = _a.theme, showFolderCover = _a.showFolderCover, folderCoverUrl = _a.folderCoverUrl, imageComponentActive = _a.imageComponentActive;
    return (_b = {},
        _b["& .".concat(classes.mainWrapperKButton)] = {
            border: "1px solid ".concat(theme.palette.grey[400]),
            justifyContent: "flex-start",
            padding: showFolderCover ? theme.spacing(1) : undefined,
            background: theme.palette.background.paper
        },
        _b["& .".concat(classes.mainWrapperBox)] = {
            border: "1px solid ".concat(theme.palette.grey[400]),
            background: theme.palette.background.paper,
            display: "grid",
            gridTemplateRows: "1fr max-content",
            width: "100%"
        },
        _b["& .".concat(classes.folderCover)] = {
            backgroundImage: folderCoverUrl && folderCoverUrl.length > 0 && !imageComponentActive
                ? "url(".concat(folderCoverUrl, ")")
                : undefined,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
            height: showFolderCover ? theme.spacing(coverSpacingCoef) : undefined,
            width: showFolderCover ? theme.spacing(coverSpacingCoef) : undefined
        },
        _b["& .".concat(classes.innerWrapper)] = {
            display: "grid",
            minHeight: "100%",
            alignItems: "stretch",
            gap: showFolderCover ? theme.spacing(1) : undefined,
            gridTemplateColumns: showFolderCover && folderCoverUrl && folderCoverUrl.length > 0
                ? "".concat(theme.spacing(coverSpacingCoef), " 1fr")
                : "0 1fr"
        },
        _b["& .".concat(classes.innerWrapperButton)] = {
            justifyContent: "flex-start"
        },
        _b["& .".concat(classes.title)] = {
            textAlign: "left",
            paddingTop: "0.5em",
            fontWeight: "bold",
            lineHeight: 1,
            marginBottom: theme.spacing(1)
        },
        _b["& .".concat(classes.icon)] = {
            marginRight: theme.spacing(0.5),
            marginTop: "3px"
        },
        _b["& .".concat(classes.mainActionLink)] = {
            display: "flex"
        },
        _b["& .".concat(classes.subFolderLink)] = {
            borderTop: "1px solid ".concat(theme.palette.grey[400]),
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            justifyContent: "flex-start",
            color: theme.palette.text.primary
        },
        _b["& .".concat(classes.folderContent)] = {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            color: theme.palette.text.primary
        },
        _b);
});
var coverSpacingCoef = 8;

export { classes, StyledKButtonFolder as default };
//# sourceMappingURL=index.styled.js.map
